// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"329dd66d","977":"6a440353"}[chunkId] + ".chunk.js";
};